import { FormGroup } from '@angular/forms';
import * as moment from 'moment-timezone';

// custom validator to check that two fields match
export function IsValidDate(controlName: string, options?) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];

        if (!options) {
            options = {};
        }

        if (!options.pattern) {
            options.pattern = 'DDMMYYYY';
        }

        if (control.errors) {
            return;
        }

        if (control.value && !moment(control.value, options.pattern, true).isValid()) {
            control.setErrors({
                invalidDate: true
            });
        } else {
            control.setErrors(null);
        }
    }
}
